(() => {
  const header = document.querySelector('#js-header[data-custom-header]');
  if (!header) return;

  const ham = header.querySelector('#js-ham');
  const triggers = header.querySelectorAll('[data-mega-trigger]');
  const megaMenus = header.querySelectorAll('[data-mega]');

  const closeAllMega = () => {
    megaMenus.forEach(m => m.classList.remove('is-open'));
    triggers.forEach(t => t.classList.remove('is-open'));
  };

  const openMegaForTrigger = (trigger) => {
    const item = trigger.closest('.mainMenu__item');
    if (!item) return;
    const mega = item.querySelector('[data-mega]');
    if (!mega) return;

    closeAllMega();
    trigger.classList.add('is-open');
    mega.classList.add('is-open');
  };

  // ヘッダーCSSと判定幅を統一する（1280px以上をデスクトップとする）。
  const desktopQuery = window.matchMedia('(min-width: 1280px)');
  const hoverQuery = window.matchMedia('(hover: hover) and (pointer: fine)');
  const isDesktop = () => desktopQuery.matches;
  const canHover = () => hoverQuery.matches;

  // --- MegaMenu interactions ---
  triggers.forEach((trigger) => {
    // Desktop: hover/focus
    trigger.addEventListener('mouseenter', () => {
      if (!isDesktop()) return;
      openMegaForTrigger(trigger);
    });

    trigger.addEventListener('focus', () => {
      if (!isDesktop()) return;
      openMegaForTrigger(trigger);
    });

    const item = trigger.closest('.mainMenu__item');
    if (item) {
      item.addEventListener('mouseleave', () => {
        if (!isDesktop()) return;
        closeAllMega();
      });
    }

    // 親リンクは子カテゴリーの表示トリガーとして扱い、ページ遷移を抑止する。
    trigger.addEventListener('click', (e) => {
      const item = trigger.closest('.mainMenu__item');
      const mega = item?.querySelector('[data-mega]');
      if (!mega) return;

      e.preventDefault();

      // マウス操作のデスクトップでは、hover表示を維持しつつクリックでも開く。
      if (isDesktop() && canHover()) {
        openMegaForTrigger(trigger);
        return;
      }

      const willOpen = !mega.classList.contains('is-open');
      closeAllMega();
      if (willOpen) {
        trigger.classList.add('is-open');
        mega.classList.add('is-open');
      }
    });
  });

  // Click outside closes
  document.addEventListener('click', (e) => {
    if (!header.contains(e.target)) {
      closeAllMega();
    }
  });

  // ESC closes
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') closeAllMega();
  });

  // --- Hamburger ---
  if (ham) {
    ham.addEventListener('click', () => {
      const opened = header.classList.toggle('is-nav-open');
      ham.setAttribute('aria-expanded', opened ? 'true' : 'false');
      closeAllMega();
    });
  }
})();
